import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

export function FloorPlansSpecial() {
  return (
    <section className="pt-4 pb-0 md:pt-6 bg-[var(--vibe-color-background)]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <RichTextContent
          path="floorplansspecial.text"
          as="div"
          className="font-heading text-xl sm:text-2xl font-bold leading-snug text-[var(--vibe-color-primary)] [&_p]:m-0"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FloorPlansSpecial',
  displayName: 'Floor Plans Special',
  tokens: {
    'floorplansspecial.text': {
      label: 'Special Text',
      type: 'richtext',
      defaultValue: '<p>Up to 1 Month Free on Selected Units!</p>',
    },
  },
};

(FloorPlansSpecial as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default FloorPlansSpecial;
